var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    {
      staticClass: "page__profile",
      attrs: { id: "settings_main", role: "main" },
    },
    [
      _c("div", { staticClass: "o-wrapper" }, [
        _c(
          "div",
          { staticClass: "o-grid" },
          [
            _c(
              "aside",
              {
                staticClass:
                  "profile__sidebar o-grid__item u-width-3/12 u-width-full@m",
              },
              [
                _c("div", { staticClass: "profile__sidebar__main" }, [
                  _c(
                    "ul",
                    [
                      _c(
                        "router-link",
                        {
                          attrs: {
                            tag: "li",
                            to: "/settings",
                            "exact-active-class": "active",
                          },
                        },
                        [_c("a", [_vm._v("Edit Profile")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          attrs: {
                            tag: "li",
                            to: "/settings/email",
                            "exact-active-class": "active",
                          },
                        },
                        [_c("a", [_vm._v("Email Preferences")])]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          attrs: {
                            tag: "li",
                            to: "/settings/interests",
                            "exact-active-class": "active",
                          },
                        },
                        [_c("a", [_vm._v("My Interests")])]
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm._m(0),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "u-width-1/12" }),
            _vm._v(" "),
            _c("router-view"),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "profile__sidebar__sub" }, [
      _c("ul", [
        _c("li", [
          _c("a", { attrs: { href: "/contact" } }, [_vm._v("Contact Us")]),
        ]),
        _vm._v(" "),
        _c("li", [_c("a", { attrs: { href: "/faqs" } }, [_vm._v("FAQ's")])]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/terms" } }, [
            _vm._v("Terms & Conditions"),
          ]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/privacy" } }, [_vm._v("Privacy Policy")]),
        ]),
        _vm._v(" "),
        _c("li", [
          _c("a", { attrs: { href: "/cookies" } }, [_vm._v("Cookie Policy")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }